import { render } from "./Documents.vue?vue&type=template&id=504dca8b"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/lockstep/Documents.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "504dca8b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('504dca8b', __exports__)) {
    api.reload('504dca8b', __exports__)
  }
  
  module.hot.accept("./Documents.vue?vue&type=template&id=504dca8b", () => {
    api.rerender('504dca8b', render)
  })

}


export default __exports__